// The Appointment stage's transcript trimming, copied from production (trackable-api
// src/lib/langgraph/transcriptOptimization.ts). Long transcripts are cut to sentences
// near scheduling words; the Outcome stage reads the full transcript.

const APPOINTMENT_KEYWORDS = [
  `appointment`,
  `schedule`,
  `book`,
  `available`,
  `calendar`,
  `tomorrow`,
  `today`,
  `next week`,
  `monday`,
  `tuesday`,
  `wednesday`,
  `thursday`,
  `friday`,
  `saturday`,
  `sunday`,
  `january`,
  `february`,
  `march`,
  `april`,
  `may`,
  `june`,
  `july`,
  `august`,
  `september`,
  `october`,
  `november`,
  `december`,
  `1st`,
  `2nd`,
  `3rd`,
  `4th`,
  `5th`,
  `6th`,
  `7th`,
  `8th`,
  `9th`,
  `10th`,
  `11th`,
  `12th`,
  `13th`,
  `14th`,
  `15th`,
  `16th`,
  `17th`,
  `18th`,
  `19th`,
  `20th`,
  `21st`,
  `22nd`,
  `23rd`,
  `24th`,
  `25th`,
  `26th`,
  `27th`,
  `28th`,
  `29th`,
  `30th`,
  `31st`,
  `morning`,
  `afternoon`,
  `evening`,
  `am`,
  `pm`,
  `date`,
  `time`,
  `reschedule`,
  `cancel`,
  `confirm`,
]

const estimateTokens = (text: string) => Math.ceil(text.length / 4)

/** Sentences containing a keyword, with `context` sentences either side. */
function extractRelevantSegments(transcription: string, keywords: string[], context: number): string {
  if (!transcription?.trim()) return ``
  const sentences = transcription.split(/[.!?]+/).filter((sentence) => sentence.trim().length > 0)
  const relevant = new Set<number>()
  sentences.forEach((sentence, index) => {
    const lower = sentence.toLowerCase()
    if (!keywords.some((keyword) => lower.includes(keyword.toLowerCase()))) return
    for (let i = Math.max(0, index - context); i <= Math.min(sentences.length - 1, index + context); i++) {
      relevant.add(i)
    }
  })
  if (relevant.size === 0) return transcription
  return [...relevant]
    .sort((a, b) => a - b)
    .map((index) => sentences[index].trim())
    .join(`. `)
    .concat(`.`)
}

export function getAppointmentContext(transcription: string, maxTokens = 1500): string {
  const tokens = estimateTokens(transcription)
  if (tokens < maxTokens * 0.6) return transcription
  const extracted = extractRelevantSegments(transcription, APPOINTMENT_KEYWORDS, 2)
  // Too little survived: the full transcript is safer.
  return estimateTokens(extracted) < tokens * 0.2 ? transcription : extracted
}
